import React, { useEffect, useMemo, useState } from "react";
import Wrapper from "../../views/common/commonWrapper";
import ApplicationForm from "./applicationForm";
import { useQuery } from "@tanstack/react-query";
import { getSchemaForApplications } from "../../utility/commonApi";
import { Select, Button, Space, Card } from "antd";
import "../../common.scss";
import backIcon from "../../assets/icons/back.svg";
import { useNavigate, useSearchParams } from "react-router-dom";

function ApplicationList() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const trustId = localStorage.getItem("trustId");
  const { data, isLoading } = useQuery({
    queryKey: ["schema", trustId],
    queryFn: () => getSchemaForApplications({ trustId }),
    keepPreviousData: true,
  });

  const schemas = useMemo(() => data?.schemas ?? [], [data]);

  const [selectedKey, setSelectedKey] = useState(null);
  const [selectedSchema, setSelectedSchema] = useState(null);
  useEffect(() => {
    if (schemas.length > 0) {
      const keyFromQuery = searchParams.get("key");

      if (keyFromQuery) {
        // Try to find schema by key or title parameter (case-insensitive)
        const schemaByKey = schemas.find(
          (item) =>
            item.title.toLowerCase() === keyFromQuery.toLowerCase() ||
            item.key?.toLowerCase() === keyFromQuery.toLowerCase()
        );
        if (schemaByKey) {
          setSelectedKey(schemaByKey.title);
          setSelectedSchema(schemaByKey);
          return;
        }
      }

      // Default to first schema if no valid query param
      if (!selectedKey) {
        const firstSchema = schemas[0];
        setSelectedKey(firstSchema.title);
        setSelectedSchema(firstSchema);
      }
    }
  }, [schemas, searchParams, selectedKey]);

  const handleSelectChange = (value) => {
    setSelectedKey(value);

    // Find the schema object to get its key
    const schemaObj = schemas.find((item) => item.title === value);

    if (schemaObj) {
      setSelectedSchema(schemaObj);

      // Update URL with the schema's key (not the title)
      const currentParams = Object.fromEntries(searchParams.entries());
      setSearchParams({ ...currentParams, key: schemaObj.key });
    } else {
      setSelectedSchema(null);
    }
  };

  const handleAddApplication = () => {
    const schemaObj = schemas.find((item) => item.key === selectedKey);
    if (schemaObj) {
      setSelectedSchema(schemaObj);
    }
  };
  const handleBack = () => {
    navigate(`/home`);
  };
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <Card className="commonCardShadow1 mb-5">
        <div style={{ width: "100%" }}>
          <div className="header-container mb-5">
            <div className="back-button-wrapper">
              <img
                onClick={() => handleBack()}
                className="back-button-link"
                src={backIcon}
                width={40}
                height={40}
                alt="Back"
              />

              <div className="title-wrapper isMobile">
                <div className="heading_div">Application Form</div>
              </div>
              <div className="isMobile"></div>
            </div>

            <div className="title-wrapper isDesktop">
              <div className="heading_div">Application Form</div>
            </div>

            <div className="dropdown-wrapper w-100">
              <label
                className="commonSmallFont commonFontFamily labelType"
                style={{ width: "100%", float: "left", padding: 5 }}
              >
                Application Type
              </label>
              <Select
                className="custom-select"
                style={{ width: "100%" }}
                placeholder="Select Application Type"
                onChange={handleSelectChange}
                value={selectedKey}
                loading={isLoading}
                suffixIcon={false}
              >
                {schemas.map((schema) => (
                  <Select.Option key={schema.title} value={schema.title}>
                    {schema.title}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>

          {selectedSchema && (
            <ApplicationForm
              schema={selectedSchema.schema}
              caseType={selectedSchema.key}
            />
          )}
        </div>
      </Card>
    </>
  );
}

export default ApplicationList;
